/** Browser-only helpers: episode download + sessionStorage archive. */

import type { EpisodeData } from "./schema";

export function episodeFilename(e: EpisodeData): string {
  const m = e.mirror ? "m" : "";
  return `streetsense_${e.level_id}_${e.variant}${m}_seed${e.seed}_a${e.attempt_number}.json`;
}

export function downloadEpisode(e: EpisodeData): void {
  const blob = new Blob([JSON.stringify(e, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = episodeFilename(e);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

const ARCHIVE_KEY = "streetsense_episodes_v1";
const ARCHIVE_MAX = 5;

/** Keep the last few completed episodes across in-session navigations. */
export function archiveEpisode(e: EpisodeData): void {
  try {
    const list = readArchive();
    list.push(e);
    while (list.length > ARCHIVE_MAX) list.shift();
    sessionStorage.setItem(ARCHIVE_KEY, JSON.stringify(list));
  } catch {
    // Quota or privacy mode — archive is best-effort; download still works.
  }
}

export function readArchive(): EpisodeData[] {
  try {
    const raw = sessionStorage.getItem(ARCHIVE_KEY);
    return raw ? (JSON.parse(raw) as EpisodeData[]) : [];
  } catch {
    return [];
  }
}
